import { R32_MATCHES, R16_MATCHES, QF_MATCHES, SF_MATCHES, FINAL_MATCHES } from "../data/bracketSlots.js";

// Complete Annexe C lookup table (495 valid combinations)
export const ANNEXE_C_LOOKUP = {
  "000011111111": {"1A":"E","1B":"J","1D":"I","1E":"F","1G":"H","1I":"G","1K":"L","1L":"K"},
  "000101111111": {"1A":"H","1B":"G","1D":"I","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "000110111111": {"1A":"E","1B":"J","1D":"I","1E":"D","1G":"H","1I":"G","1K":"L","1L":"K"},
  "000111011111": {"1A":"E","1B":"J","1D":"I","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "000111101111": {"1A":"E","1B":"G","1D":"I","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "000111110111": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "000111111011": {"1A":"E","1B":"G","1D":"I","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "000111111101": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "000111111110": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "001001111111": {"1A":"H","1B":"G","1D":"I","1E":"C","1G":"J","1I":"F","1K":"L","1L":"K"},
  "001010111111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"H","1I":"G","1K":"L","1L":"K"},
  "001011011111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001011101111": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"J","1I":"F","1K":"L","1L":"K"},
  "001011110111": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001011111011": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001011111101": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"F","1K":"L","1L":"I"},
  "001011111110": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"F","1K":"I","1L":"K"},
  "001100111111": {"1A":"H","1B":"G","1D":"I","1E":"C","1G":"J","1I":"D","1K":"L","1L":"K"},
  "001101011111": {"1A":"C","1B":"J","1D":"I","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001101101111": {"1A":"C","1B":"G","1D":"I","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "001101110111": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001101111011": {"1A":"C","1B":"G","1D":"I","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001101111101": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "001101111110": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "001110011111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "001110101111": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"J","1I":"D","1K":"L","1L":"K"},
  "001110110111": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "001110111011": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "001110111101": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"D","1K":"L","1L":"I"},
  "001110111110": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"H","1I":"D","1K":"I","1L":"K"},
  "001111001111": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "001111010111": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001111011011": {"1A":"C","1B":"E","1D":"I","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001111011101": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "001111011110": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "001111100111": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "001111101011": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "001111101101": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"J","1I":"F","1K":"L","1L":"I"},
  "001111101110": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"J","1I":"F","1K":"I","1L":"K"},
  "001111110011": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "001111110101": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"L","1L":"E"},
  "001111110110": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"E","1L":"K"},
  "001111111001": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "001111111010": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "001111111100": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"H","1I":"F","1K":"E","1L":"I"},
  "010001111111": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"I","1I":"G","1K":"L","1L":"K"},
  "010010111111": {"1A":"E","1B":"J","1D":"I","1E":"B","1G":"H","1I":"G","1K":"L","1L":"K"},
  "010011011111": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"I","1I":"H","1K":"L","1L":"K"},
  "010011101111": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"I","1I":"G","1K":"L","1L":"K"},
  "010011110111": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"H","1I":"G","1K":"L","1L":"K"},
  "010011111011": {"1A":"E","1B":"G","1D":"B","1E":"F","1G":"I","1I":"H","1K":"L","1L":"K"},
  "010011111101": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"H","1I":"G","1K":"L","1L":"I"},
  "010011111110": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"H","1I":"G","1K":"I","1L":"K"},
  "010100111111": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"I","1I":"G","1K":"L","1L":"K"},
  "010101011111": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "010101101111": {"1A":"I","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "010101110111": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "010101111011": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "010101111101": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"I"},
  "010101111110": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"I","1L":"K"},
  "010110011111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"I","1I":"H","1K":"L","1L":"K"},
  "010110101111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"I","1I":"G","1K":"L","1L":"K"},
  "010110110111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"G","1K":"L","1L":"K"},
  "010110111011": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"I","1I":"H","1K":"L","1L":"K"},
  "010110111101": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"G","1K":"L","1L":"I"},
  "010110111110": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"G","1K":"I","1L":"K"},
  "010111001111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "010111010111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "010111011011": {"1A":"E","1B":"I","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "010111011101": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "010111011110": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "010111100111": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "010111101011": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "010111101101": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"I"},
  "010111101110": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"I","1L":"K"},
  "010111110011": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "010111110101": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"E"},
  "010111110110": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"E","1L":"K"},
  "010111111001": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "010111111010": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "010111111100": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"E","1L":"I"},
  "011000111111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"I","1I":"G","1K":"L","1L":"K"},
  "011001011111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011001101111": {"1A":"I","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"K"},
  "011001110111": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"K"},
  "011001111011": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011001111101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"I"},
  "011001111110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"I","1L":"K"},
  "011010011111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"I","1I":"H","1K":"L","1L":"K"},
  "011010101111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"I","1I":"G","1K":"L","1L":"K"},
  "011010110111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"G","1K":"L","1L":"K"},
  "011010111011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"I","1I":"H","1K":"L","1L":"K"},
  "011010111101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"G","1K":"L","1L":"I"},
  "011010111110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"G","1K":"I","1L":"K"},
  "011011001111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011011010111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011011011011": {"1A":"E","1B":"I","1D":"B","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011011011101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"F","1K":"L","1L":"I"},
  "011011011110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"F","1K":"I","1L":"K"},
  "011011100111": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"K"},
  "011011101011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011011101101": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"I"},
  "011011101110": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"I","1L":"K"},
  "011011110011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011011110101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"L","1L":"E"},
  "011011110110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"E","1L":"K"},
  "011011111001": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"F","1K":"L","1L":"I"},
  "011011111010": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"F","1K":"I","1L":"K"},
  "011011111100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"E","1L":"I"},
  "011100011111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"I","1I":"D","1K":"L","1L":"K"},
  "011100101111": {"1A":"I","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"K"},
  "011100110111": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"K"},
  "011100111011": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"I","1I":"D","1K":"L","1L":"K"},
  "011100111101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"I"},
  "011100111110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"I","1L":"K"},
  "011101001111": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011101010111": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011101011011": {"1A":"C","1B":"I","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011101011101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "011101011110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "011101100111": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"K"},
  "011101101011": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011101101101": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"I"},
  "011101101110": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"I","1L":"K"},
  "011101110011": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011101110101": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"J"},
  "011101110110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"D","1L":"K"},
  "011101111001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "011101111010": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "011101111100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"D","1L":"I"},
  "011110001111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"I","1I":"D","1K":"L","1L":"K"},
  "011110010111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "011110011011": {"1A":"E","1B":"I","1D":"B","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "011110011101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"D","1K":"L","1L":"I"},
  "011110011110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"H","1I":"D","1K":"I","1L":"K"},
  "011110100111": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"K"},
  "011110101011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"I","1I":"D","1K":"L","1L":"K"},
  "011110101101": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"I"},
  "011110101110": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"I","1L":"K"},
  "011110110011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"D","1K":"L","1L":"K"},
  "011110110101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"L","1L":"E"},
  "011110110110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"E","1L":"K"},
  "011110111001": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"D","1K":"L","1L":"I"},
  "011110111010": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"H","1I":"D","1K":"I","1L":"K"},
  "011110111100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"D","1K":"E","1L":"I"},
  "011111000111": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"E","1I":"F","1K":"L","1L":"K"},
  "011111001011": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"I","1I":"F","1K":"L","1L":"K"},
  "011111001101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"E","1I":"F","1K":"L","1L":"I"},
  "011111001110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"E","1I":"F","1K":"I","1L":"K"},
  "011111010011": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"K"},
  "011111010101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"E"},
  "011111010110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"E","1L":"K"},
  "011111011001": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"I"},
  "011111011010": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"H","1I":"F","1K":"I","1L":"K"},
  "011111011100": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"H","1I":"F","1K":"E","1L":"I"},
  "011111100011": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"E","1I":"F","1K":"L","1L":"K"},
  "011111100101": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"L","1L":"E"},
  "011111100110": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"E","1L":"K"},
  "011111101001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"E","1I":"F","1K":"L","1L":"I"},
  "011111101010": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"E","1I":"F","1K":"I","1L":"K"},
  "011111101100": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"J","1I":"F","1K":"E","1L":"I"},
  "011111110001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"L","1L":"E"},
  "011111110010": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"E","1L":"K"},
  "011111110100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"J","1I":"F","1K":"D","1L":"E"},
  "011111111000": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"H","1I":"F","1K":"E","1L":"I"},
  "100001111111": {"1A":"H","1B":"J","1D":"I","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "100010111111": {"1A":"E","1B":"J","1D":"I","1E":"A","1G":"H","1I":"G","1K":"L","1L":"K"},
  "100011011111": {"1A":"E","1B":"J","1D":"I","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100011101111": {"1A":"E","1B":"J","1D":"I","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "100011110111": {"1A":"E","1B":"G","1D":"J","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100011111011": {"1A":"E","1B":"G","1D":"I","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100011111101": {"1A":"E","1B":"G","1D":"J","1E":"F","1G":"A","1I":"H","1K":"L","1L":"I"},
  "100011111110": {"1A":"E","1B":"G","1D":"J","1E":"F","1G":"A","1I":"H","1K":"I","1L":"K"},
  "100100111111": {"1A":"H","1B":"J","1D":"I","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "100101011111": {"1A":"H","1B":"J","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100101101111": {"1A":"I","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100101110111": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100101111011": {"1A":"H","1B":"G","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100101111101": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "100101111110": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "100110011111": {"1A":"E","1B":"J","1D":"I","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100110101111": {"1A":"E","1B":"J","1D":"I","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "100110110111": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100110111011": {"1A":"E","1B":"G","1D":"I","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "100110111101": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"H","1K":"L","1L":"I"},
  "100110111110": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"H","1K":"I","1L":"K"},
  "100111001111": {"1A":"E","1B":"J","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111010111": {"1A":"H","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111011011": {"1A":"H","1B":"E","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111011101": {"1A":"H","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "100111011110": {"1A":"H","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "100111100111": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111101011": {"1A":"E","1B":"G","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111101101": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "100111101110": {"1A":"E","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "100111110011": {"1A":"H","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "100111110101": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "100111110110": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "100111111001": {"1A":"H","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "100111111010": {"1A":"H","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "100111111100": {"1A":"H","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "101000111111": {"1A":"H","1B":"J","1D":"I","1E":"C","1G":"A","1I":"G","1K":"L","1L":"K"},
  "101001011111": {"1A":"H","1B":"J","1D":"I","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101001101111": {"1A":"I","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101001110111": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101001111011": {"1A":"H","1B":"G","1D":"I","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101001111101": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101001111110": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101010011111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "101010101111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"A","1I":"G","1K":"L","1L":"K"},
  "101010110111": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "101010111011": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "101010111101": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"H","1K":"L","1L":"I"},
  "101010111110": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"H","1K":"I","1L":"K"},
  "101011001111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011010111": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011011011": {"1A":"H","1B":"E","1D":"I","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011011101": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101011011110": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101011100111": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011101011": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011101101": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101011101110": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101011110011": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101011110101": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"L","1L":"E"},
  "101011110110": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"E","1L":"K"},
  "101011111001": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101011111010": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101011111100": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"E","1L":"I"},
  "101100011111": {"1A":"H","1B":"J","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101100101111": {"1A":"I","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101100110111": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101100111011": {"1A":"H","1B":"G","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101100111101": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101100111110": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101101001111": {"1A":"C","1B":"J","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101101010111": {"1A":"H","1B":"J","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101101011011": {"1A":"H","1B":"F","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101101011101": {"1A":"H","1B":"J","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101101011110": {"1A":"H","1B":"J","1D":"F","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101101100111": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101101101011": {"1A":"C","1B":"G","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101101101101": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101101101110": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101101110011": {"1A":"H","1B":"G","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101101110101": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"H"},
  "101101110110": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "101101111001": {"1A":"H","1B":"G","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101101111010": {"1A":"H","1B":"G","1D":"F","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101101111100": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "101110001111": {"1A":"E","1B":"J","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110010111": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110011011": {"1A":"H","1B":"E","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110011101": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101110011110": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101110100111": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110101011": {"1A":"E","1B":"G","1D":"I","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110101101": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101110101110": {"1A":"E","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101110110011": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101110110101": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "101110110110": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"E","1L":"K"},
  "101110111001": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101110111010": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101110111100": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"D","1K":"E","1L":"I"},
  "101111000111": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101111001011": {"1A":"C","1B":"E","1D":"I","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101111001101": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101111001110": {"1A":"C","1B":"J","1D":"E","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101111010011": {"1A":"H","1B":"E","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "101111010101": {"1A":"H","1B":"J","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "101111010110": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "101111011001": {"1A":"H","1B":"E","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "101111011010": {"1A":"H","1B":"E","1D":"F","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "101111011100": {"1A":"H","1B":"J","1D":"E","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "101111100011": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "101111100101": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "101111100110": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "101111101001": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "101111101010": {"1A":"C","1B":"G","1D":"E","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "101111101100": {"1A":"C","1B":"G","1D":"J","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "101111110001": {"1A":"H","1B":"G","1D":"F","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "101111110010": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "101111110100": {"1A":"H","1B":"G","1D":"J","1E":"C","1G":"A","1I":"F","1K":"D","1L":"E"},
  "101111111000": {"1A":"H","1B":"G","1D":"E","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "110000111111": {"1A":"H","1B":"J","1D":"B","1E":"A","1G":"I","1I":"G","1K":"L","1L":"K"},
  "110001011111": {"1A":"H","1B":"J","1D":"B","1E":"A","1G":"I","1I":"F","1K":"L","1L":"K"},
  "110001101111": {"1A":"I","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110001110111": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110001111011": {"1A":"H","1B":"G","1D":"B","1E":"A","1G":"I","1I":"F","1K":"L","1L":"K"},
  "110001111101": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"I"},
  "110001111110": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"I","1L":"K"},
  "110010011111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"I","1I":"H","1K":"L","1L":"K"},
  "110010101111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"I","1I":"G","1K":"L","1L":"K"},
  "110010110111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"H","1I":"G","1K":"L","1L":"K"},
  "110010111011": {"1A":"E","1B":"G","1D":"B","1E":"A","1G":"I","1I":"H","1K":"L","1L":"K"},
  "110010111101": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"H","1I":"G","1K":"L","1L":"I"},
  "110010111110": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"H","1I":"G","1K":"I","1L":"K"},
  "110011001111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"I","1I":"F","1K":"L","1L":"K"},
  "110011010111": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110011011011": {"1A":"E","1B":"I","1D":"B","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110011011101": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"H","1K":"L","1L":"I"},
  "110011011110": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"H","1K":"I","1L":"K"},
  "110011100111": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110011101011": {"1A":"E","1B":"G","1D":"B","1E":"A","1G":"I","1I":"F","1K":"L","1L":"K"},
  "110011101101": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"I"},
  "110011101110": {"1A":"E","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"I","1L":"K"},
  "110011110011": {"1A":"E","1B":"G","1D":"B","1E":"F","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110011110101": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"E"},
  "110011110110": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"E","1L":"K"},
  "110011111001": {"1A":"E","1B":"G","1D":"B","1E":"F","1G":"A","1I":"H","1K":"L","1L":"I"},
  "110011111010": {"1A":"E","1B":"G","1D":"B","1E":"F","1G":"A","1I":"H","1K":"I","1L":"K"},
  "110011111100": {"1A":"H","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"E","1L":"I"},
  "110100011111": {"1A":"I","1B":"J","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110100101111": {"1A":"I","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110100110111": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110100111011": {"1A":"I","1B":"G","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110100111101": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"I"},
  "110100111110": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"I","1L":"K"},
  "110101001111": {"1A":"I","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110101010111": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110101011011": {"1A":"H","1B":"I","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110101011101": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "110101011110": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "110101100111": {"1A":"F","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110101101011": {"1A":"I","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110101101101": {"1A":"F","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"I"},
  "110101101110": {"1A":"F","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"I","1L":"K"},
  "110101110011": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110101110101": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"J"},
  "110101110110": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"J","1L":"K"},
  "110101111001": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "110101111010": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "110101111100": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"J"},
  "110110001111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"I","1I":"D","1K":"L","1L":"K"},
  "110110010111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110110011011": {"1A":"E","1B":"I","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110110011101": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"I"},
  "110110011110": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"H","1K":"I","1L":"K"},
  "110110100111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "110110101011": {"1A":"E","1B":"G","1D":"B","1E":"A","1G":"I","1I":"D","1K":"L","1L":"K"},
  "110110101101": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"I"},
  "110110101110": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"I","1L":"K"},
  "110110110011": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"K"},
  "110110110101": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"E"},
  "110110110110": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"E","1L":"K"},
  "110110111001": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"H","1K":"L","1L":"I"},
  "110110111010": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"H","1K":"I","1L":"K"},
  "110110111100": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"E","1L":"I"},
  "110111000111": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110111001011": {"1A":"E","1B":"I","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110111001101": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "110111001110": {"1A":"E","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "110111010011": {"1A":"H","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110111010101": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "110111010110": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "110111011001": {"1A":"H","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "110111011010": {"1A":"H","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "110111011100": {"1A":"H","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "110111100011": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "110111100101": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"J"},
  "110111100110": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"J","1L":"K"},
  "110111101001": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "110111101010": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "110111101100": {"1A":"E","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"J"},
  "110111110001": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "110111110010": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "110111110100": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"J"},
  "110111111000": {"1A":"H","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "111000011111": {"1A":"I","1B":"J","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "111000101111": {"1A":"I","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"K"},
  "111000110111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"K"},
  "111000111011": {"1A":"I","1B":"G","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "111000111101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"I"},
  "111000111110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"I","1L":"K"},
  "111001001111": {"1A":"I","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111001010111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111001011011": {"1A":"H","1B":"I","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111001011101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111001011110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111001100111": {"1A":"C","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"K"},
  "111001101011": {"1A":"I","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111001101101": {"1A":"C","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"L","1L":"I"},
  "111001101110": {"1A":"C","1B":"J","1D":"B","1E":"F","1G":"A","1I":"G","1K":"I","1L":"K"},
  "111001110011": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111001110101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"J"},
  "111001110110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"J","1L":"K"},
  "111001111001": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111001111010": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111001111100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"J"},
  "111010001111": {"1A":"E","1B":"J","1D":"B","1E":"A","1G":"I","1I":"C","1K":"L","1L":"K"},
  "111010010111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "111010011011": {"1A":"E","1B":"I","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "111010011101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"I"},
  "111010011110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"H","1K":"I","1L":"K"},
  "111010100111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"K"},
  "111010101011": {"1A":"E","1B":"G","1D":"B","1E":"A","1G":"I","1I":"C","1K":"L","1L":"K"},
  "111010101101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"I"},
  "111010101110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"I","1L":"K"},
  "111010110011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"K"},
  "111010110101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"L","1L":"E"},
  "111010110110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"E","1L":"K"},
  "111010111001": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"H","1K":"L","1L":"I"},
  "111010111010": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"H","1K":"I","1L":"K"},
  "111010111100": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"G","1K":"E","1L":"I"},
  "111011000111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111011001011": {"1A":"E","1B":"I","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111011001101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111011001110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111011010011": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111011010101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"E"},
  "111011010110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"E","1L":"K"},
  "111011011001": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111011011010": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111011011100": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"E","1L":"I"},
  "111011100011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111011100101": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"J"},
  "111011100110": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"J","1L":"K"},
  "111011101001": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111011101010": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111011101100": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"I","1L":"J"},
  "111011110001": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"L","1L":"E"},
  "111011110010": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"E","1L":"K"},
  "111011110100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"E","1L":"J"},
  "111011111000": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"E","1L":"I"},
  "111100001111": {"1A":"I","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111100010111": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111100011011": {"1A":"H","1B":"I","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111100011101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111100011110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111100100111": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"K"},
  "111100101011": {"1A":"I","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111100101101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"L","1L":"I"},
  "111100101110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"G","1K":"I","1L":"K"},
  "111100110011": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111100110101": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"J"},
  "111100110110": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"J","1L":"K"},
  "111100111001": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111100111010": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111100111100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"J"},
  "111101000111": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111101001011": {"1A":"C","1B":"I","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111101001101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111101001110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111101010011": {"1A":"H","1B":"F","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111101010101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"H"},
  "111101010110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "111101011001": {"1A":"H","1B":"F","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111101011010": {"1A":"H","1B":"F","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111101011100": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "111101100011": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111101100101": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"J"},
  "111101100110": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"J","1L":"K"},
  "111101101001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111101101010": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111101101100": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"J"},
  "111101110001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"H"},
  "111101110010": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "111101110100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"J"},
  "111101111000": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "111110000111": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111110001011": {"1A":"E","1B":"I","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111110001101": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111110001110": {"1A":"E","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111110010011": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111110010101": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "111110010110": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"E","1L":"K"},
  "111110011001": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111110011010": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111110011100": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"D","1K":"E","1L":"I"},
  "111110100011": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"K"},
  "111110100101": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"J"},
  "111110100110": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"J","1L":"K"},
  "111110101001": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"I"},
  "111110101010": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"K"},
  "111110101100": {"1A":"E","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"I","1L":"J"},
  "111110110001": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "111110110010": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"E","1L":"K"},
  "111110110100": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"E","1L":"J"},
  "111110111000": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"D","1K":"E","1L":"I"},
  "111111000011": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"K"},
  "111111000101": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "111111000110": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "111111001001": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"I"},
  "111111001010": {"1A":"C","1B":"E","1D":"B","1E":"D","1G":"A","1I":"F","1K":"I","1L":"K"},
  "111111001100": {"1A":"C","1B":"J","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "111111010001": {"1A":"H","1B":"F","1D":"B","1E":"C","1G":"A","1I":"D","1K":"L","1L":"E"},
  "111111010010": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"K"},
  "111111010100": {"1A":"H","1B":"J","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"E"},
  "111111011000": {"1A":"H","1B":"E","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"I"},
  "111111100001": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"L","1L":"E"},
  "111111100010": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"K"},
  "111111100100": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"J"},
  "111111101000": {"1A":"C","1B":"G","1D":"B","1E":"D","1G":"A","1I":"F","1K":"E","1L":"I"},
  "111111110000": {"1A":"H","1B":"G","1D":"B","1E":"C","1G":"A","1I":"F","1K":"D","1L":"E"}
};
// Assign 8 qualified third-place teams to bracket slots using Annexe C lookup table
export function assignThirdPlaceSlots(advancedTeams) {
  const { qualifiedThirds, thirdRankings } = advancedTeams;

  console.log("=== ANNEXE C ASSIGNMENT DEBUG ===");
  console.log("qualifiedThirds:", qualifiedThirds);
  console.log("thirdRankings (top 8):", thirdRankings.slice(0, 8).map(t => ({ team: t.team, group: t.group })));

  if (qualifiedThirds.length < 8) {
    console.log("WARNING: qualifiedThirds.length =", qualifiedThirds.length, "< 8");
    return {};
  }

  // Build a 12-character binary key: "1" if that group's third qualified, "0" if not
  // Groups are ordered A through L (indices 0-11)
  const groupLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];

  // Build qualifiedGroups from the actual qualifiedThirds teams
  // This ensures the binary key represents the exact 8 groups that qualified
  const qualifiedGroups = new Set();
  qualifiedThirds.forEach(teamName => {
    const ranking = thirdRankings.find(t => t.team === teamName);
    if (ranking && ranking.group) {
      qualifiedGroups.add(ranking.group);
    }
  });

  console.log("qualifiedGroups (Set):", Array.from(qualifiedGroups));

  const binaryKey = groupLetters.map(g => qualifiedGroups.has(g) ? '1' : '0').join('');

  console.log("binaryKey:", binaryKey);
  console.log("ANNEXE_C_LOOKUP has this key?", !!ANNEXE_C_LOOKUP[binaryKey]);

  // Look up the Annexe C combination
  const slotMappings = ANNEXE_C_LOOKUP[binaryKey];
  console.log("slotMappings result:", slotMappings);

  if (!slotMappings) {
    console.error("ERROR: No slotMappings found for key", binaryKey);
    return {};
  }

  // Map group letters to team names
  // Create a mapping of group → third-place team
  const groupToTeam = {};
  qualifiedThirds.forEach(team => {
    const ranking = thirdRankings.find(t => t.team === team);
    if (ranking) {
      groupToTeam[ranking.group] = team;
    }
  });

  console.log("groupToTeam mapping:", groupToTeam);

  // Convert slot mappings (e.g., "1A" → "E") to match numbers → team names
  // The slot mapping keys like "1A" tell us which group's third goes to group winner 1A
  // We need to map this to match numbers in R32
  const slotAssignment = {};

  // Map group winner codes to R32 match numbers that have third-place slots
  const groupWinnerToMatch = {
    "1A": 79,   // M79: 1A vs 3rd(CEFHI)
    "1B": 85,   // M85: 1B vs 3rd(EFGIJ)
    "1D": 81,   // M81: 1D vs 3rd(BEFIJ)
    "1E": 74,   // M74: 1E vs 3rd(ABCDF)
    "1G": 82,   // M82: 1G vs 3rd(AEHIJ)
    "1I": 77,   // M77: 1I vs 3rd(CDFGH)
    "1K": 87,   // M87: 1K vs 3rd(DEIJL)
    "1L": 80,   // M80: 1L vs 3rd(EHIJK)
  };

  // Process the slot mappings
  Object.entries(slotMappings).forEach(([winnerCode, groupLetter]) => {
    const matchNum = groupWinnerToMatch[winnerCode];
    const team = groupToTeam[groupLetter];
    console.log(`  ${winnerCode} → group ${groupLetter}: matchNum=${matchNum}, team=${team}`);
    if (matchNum && team) {
      slotAssignment[matchNum] = team;
    } else {
      console.log(`    ⚠️  SKIPPED: matchNum=${matchNum}, team=${team}`);
    }
  });

  console.log("final slotAssignment:", slotAssignment);
  console.log("=== END DEBUG ===\n");

  return slotAssignment;
}

// Populate the full bracket with team names based on group results and advancement
export function populateBracket(advancedTeams, slotAssignment, knockoutResults) {
  const { firsts, seconds } = advancedTeams;

  // Build a map of all knockout matches
  const bracket = {};
  const allMatches = [...R32_MATCHES, ...R16_MATCHES, ...QF_MATCHES, ...SF_MATCHES, ...FINAL_MATCHES];

  allMatches.forEach((matchDef) => {
    bracket[matchDef.matchNum] = {
      matchNum: matchDef.matchNum,
      round: matchDef.round,
      label: matchDef.label,
      homeTeam: null,
      awayTeam: null,
      winner: null,
      loser: null,
    };
  });

  // Helper to resolve team references
  const resolveTeam = (ref) => {
    if (typeof ref === "string") return ref;
    if (ref.type === "1st") return firsts[ref.group];
    if (ref.type === "2nd") return seconds[ref.group];
    if (ref.type === "3rd") return null; // Will be handled separately with slotAssignment
    if (ref.type === "winner") {
      const prevMatch = bracket[ref.matchNum];
      return prevMatch?.winner || null;
    }
    if (ref.type === "loser") {
      const prevMatch = bracket[ref.matchNum];
      return prevMatch?.loser || null;
    }
    return null;
  };

  // Helper to compute winner/loser from results
  const computeWinnerFromResults = (matchNum) => {
    const result = knockoutResults[matchNum];
    if (!result || result.homeGoals === null || result.awayGoals === null) {
      return null;
    }

    const match = bracket[matchNum];
    if (!match.homeTeam || !match.awayTeam) return null;

    if (result.homeGoals > result.awayGoals) {
      return { winner: match.homeTeam, loser: match.awayTeam };
    } else if (result.awayGoals > result.homeGoals) {
      return { winner: match.awayTeam, loser: match.homeTeam };
    } else {
      // Tied - penalties determine winner
      if (result.penaltyWinner === "home") {
        return { winner: match.homeTeam, loser: match.awayTeam };
      } else if (result.penaltyWinner === "away") {
        return { winner: match.awayTeam, loser: match.homeTeam };
      }
    }
    return null;
  };

  // Populate R32 matches (from group results)
  R32_MATCHES.forEach((matchDef) => {
    let home = resolveTeam(matchDef.home);
    let away = resolveTeam(matchDef.away);

    // Handle third-place slots
    if (matchDef.home.type === "3rd") {
      home = slotAssignment[matchDef.matchNum] || null;
    }
    if (matchDef.away.type === "3rd") {
      away = slotAssignment[matchDef.matchNum] || null;
    }

    bracket[matchDef.matchNum].homeTeam = home;
    bracket[matchDef.matchNum].awayTeam = away;

    // Compute winner if scores are entered
    const result = computeWinnerFromResults(matchDef.matchNum);
    if (result) {
      bracket[matchDef.matchNum].winner = result.winner;
      bracket[matchDef.matchNum].loser = result.loser;
    }
  });

  // Populate subsequent rounds based on winners from previous round
  const allRounds = [R16_MATCHES, QF_MATCHES, SF_MATCHES, FINAL_MATCHES];
  allRounds.forEach((round) => {
    round.forEach((matchDef) => {
      const home = resolveTeam(matchDef.home);
      const away = resolveTeam(matchDef.away);

      bracket[matchDef.matchNum].homeTeam = home;
      bracket[matchDef.matchNum].awayTeam = away;

      // Compute winner if scores are entered
      const result = computeWinnerFromResults(matchDef.matchNum);
      if (result) {
        bracket[matchDef.matchNum].winner = result.winner;
        bracket[matchDef.matchNum].loser = result.loser;
      }
    });
  });

  return bracket;
}
